import React from "react";

export const Headersub = ({ icon, title, icon1, ImageIcon }) => {
  return (
    <div className="breadcrumb-new">
      <div className="row">
        <div className="col-sm-12 col-md-12 title-cd">
          <div className="media-home align-center-home">
            <div className="bg-icon-bredcrumb">
              {" "}
              {ImageIcon ? (
                <img className="icon-bred-home" src={icon} alt="" />
              ) : (
                <i class={icon1}></i>
              )}
            </div>
            <div className="media-body-home">
              <h2 className="text-info-home">{title}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
